import React from 'react';
import Icon from '../../../components/AppIcon';

const STEPS = [
  { id: 1, label: 'Personal Info', icon: 'User' },
  { id: 2, label: 'Identity KYC', icon: 'ShieldCheck' },
  { id: 3, label: 'Social Verify', icon: 'Star' },
  { id: 4, label: 'Review', icon: 'ClipboardCheck' },
];

const StepIndicator = ({ currentStep }) => {
  return (
    <div className="w-full">
      {/* Desktop */}
      <div className="hidden sm:flex items-center justify-between relative">
        <div
          className="absolute top-5 left-0 right-0 h-px"
          style={{ background: 'rgba(255,255,255,0.08)', zIndex: 0 }}
        />
        <div
          className="absolute top-5 left-0 h-px transition-all duration-500"
          style={{
            background: 'linear-gradient(90deg, #0d9488, #1d4ed8)',
            width: `${((currentStep - 1) / (STEPS?.length - 1)) * 100}%`,
            zIndex: 1,
          }}
        />
        {STEPS?.map((step) => {
          const isCompleted = currentStep > step?.id;
          const isActive = currentStep === step?.id;
          return (
            <div key={step?.id} className="flex flex-col items-center gap-2 relative z-10">
              <div
                className="w-10 h-10 rounded-full flex items-center justify-center transition-all duration-300"
                style={{
                  background: isCompleted
                    ? 'linear-gradient(135deg, #0d9488, #1d4ed8)'
                    : isActive
                    ? 'rgba(13,148,136,0.2)'
                    : 'rgba(255,255,255,0.05)',
                  border: isActive
                    ? '2px solid #14B8A6'
                    : isCompleted
                    ? '2px solid transparent' :'2px solid rgba(255,255,255,0.12)',
                  boxShadow: isActive ? '0 0 16px rgba(20,184,166,0.35)' : 'none',
                }}
              >
                {isCompleted ? (
                  <Icon name="Check" size={16} color="#fff" />
                ) : (
                  <Icon
                    name={step?.icon}
                    size={16}
                    color={isActive ? '#14B8A6' : 'rgba(255,255,255,0.35)'}
                  />
                )}
              </div>
              <span
                className="text-xs font-medium whitespace-nowrap"
                style={{ color: isActive ? '#14B8A6' : isCompleted ? '#fff' : 'rgba(255,255,255,0.4)' }}
              >
                {step?.label}
              </span>
            </div>
          );
        })}
      </div>
      {/* Mobile */}
      <div className="flex sm:hidden items-center justify-between">
        {STEPS?.map((step, idx) => {
          const isCompleted = currentStep > step?.id;
          const isActive = currentStep === step?.id;
          return (
            <React.Fragment key={step?.id}>
              <div className="flex flex-col items-center gap-1">
                <div
                  className="w-8 h-8 rounded-full flex items-center justify-center"
                  style={{
                    background: isCompleted
                      ? 'linear-gradient(135deg, #0d9488, #1d4ed8)'
                      : isActive
                      ? 'rgba(13,148,136,0.2)'
                      : 'rgba(255,255,255,0.05)',
                    border: isActive ? '2px solid #14B8A6' : isCompleted ? '2px solid transparent' : '2px solid rgba(255,255,255,0.1)',
                  }}
                >
                  {isCompleted ? (
                    <Icon name="Check" size={12} color="#fff" />
                  ) : (
                    <span className="text-xs font-bold" style={{ color: isActive ? '#14B8A6' : 'rgba(255,255,255,0.35)' }}>
                      {step?.id}
                    </span>
                  )}
                </div>
                <span
                  className="text-[10px] font-medium"
                  style={{ color: isActive ? '#14B8A6' : 'rgba(255,255,255,0.35)' }}
                >
                  {step?.label?.split(' ')?.[0]}
                </span>
              </div>
              {idx < STEPS?.length - 1 && (
                <div
                  className="flex-1 h-px mx-1"
                  style={{
                    background: isCompleted
                      ? 'linear-gradient(90deg, #0d9488, #1d4ed8)'
                      : 'rgba(255,255,255,0.08)',
                  }}
                />
              )}
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
};

export default StepIndicator;
